import seoReducerMap from 'wanderu-ducks-seo';

import NewRoutes from '../containers/NewRoutes/NewRoutes';

function onLoad(module, info, props, context) {
    context.store.inject(seoReducerMap);
}

export { onLoad };
export default NewRoutes;
